import OrganizationEngagementViewScreenshotFigures from './OrganizationEngagementViewScreenshotFigures';

export default OrganizationEngagementViewScreenshotFigures;
